<template>    
    <BaseModal
        :id="'static-update'"
        :title="title"
        :size="'lg'"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="form_submit_update(single_object.id, global_index)">
                <FormDynamic
                    :form_format="form_format"
                    :form_data="single_object"
                    :array_options="array_options"
                    :for_update="true"
                />
                <CentralButtons /> 
            </form>
        </template>
    </BaseModal>
</template>

<script>

import FormResources    from    './form_resources'
import FormDynamic      from    '@/components/FormDynamic.vue'
import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal        from    '@/components/BaseModal'
import CentralButtons   from    '@/components/CentralButtons'

export default {

    name:   'UpdateModal',
    props: [
        'title',
        'content_header',
        'rest_api',
        'notifications',
        'notyf',
        'single_object',
        'global_index',
        "array_options",
        "breadcrumb",
    ],

    components:{
        FormDynamic,
        Breadcrumb,
        BaseModal,
        CentralButtons,
    },

    data(){
        return{
            levels:         [],
            areas:          [],
            form_data:      FormResources.form_data,
            form_format:    FormResources.form_format,
            form_backup:    {...FormResources.form_data},
        }
    },
    
    methods:{},

    watch: {
         async 'single_object.building_id'(val){
            if(val){
              
                let http_request = {
                  request_id:     val,
                  rooms_request:  false,  
                  levels_request: true,
                  areas_request:  false,
                }
                const response = await this.get(`${this.rest_api}/${JSON.stringify(http_request)}`)
                if(response.status) {
                     if(response.data.levels.length){
                      
                        this.array_options['level_id']  = response.data.levels
                        this.array_options['room_id']   = response.data.rooms

                    }else{
                      
                        this.array_options['level_id']  = []
                        this.array_options['area_id']   = []
                        this.array_options['room_id']   = []
                        this.single_object.level_id     = ''
                        // this.single_object.area_id      = ''
                        // this.single_object.room_id      = []

                    }
                } else {
                    this.error_handling(response)
                }
                

            }else{
                this.array_options['level_id']  = []
                this.array_options['area_id']   = []
                this.array_options['room_id']   = []
            }

        },

        async 'single_object.level_id'(val){

            if(val){
              
                let level_room = this.array_options['level_id'].find(prop => prop.id === val)

                level_room != '' ? 
                    this.array_options['room_id'] = level_room.rooms 
                    : 
                    this.array_options['room_id'] = []

                let http_request = {
                    request_id:     val,
                    rooms_request:  false,  
                    levels_request: false,
                    areas_request:  true,
                }
                const response = await this.get(`${this.rest_api}/${JSON.stringify(http_request)}`)
                if(response.status) {
                     if(response.data.areas.length){
                      this.array_options['area_id'] = response.data.areas
                    //   this.single_object.area_id    = ''
                    }else{
                      this.array_options['area_id'] = []
                    //   this.single_object.area_id    = ''
                    }
                } else {
                    this.error_handling(response)
                }

            }else{
              
                this.array_options['area_id'] = []
                this.array_options['room_id'] = []
                this.single_object.area_id    = ''
                this.single_object.room_id    = ''

            }

        },

        'single_object.area_id'(val){
            if(val){
            
                let area_room = this.array_options['area_id'].find(prop => prop.id === val)
                area_room != undefined ? 
                    this.array_options['room_id'] = area_room.rooms 
                    : 
                    this.array_options['room_id'] = []
            }
        },
    },

    mounted(){

    }
    
}
</script>